export const environment = {
  production: true,
  apiUrl: 'https://chat.drafters.info',
  draftUrl: 'https://draft.drafters.info',
  chatUrl: 'https://chat.drafters.info',
  boxScoreUrl: 'https://node.drafters.info',
  adminUrl: 'https://admin.drafters.info',
  phpApiUrl: 'https://api.drafters.info',
  phpUrl: 'https://drafters.info',
  assetURL: 'https://draftersnew.s3.amazonaws.com',
  assetUploadURL: 'https://draftersnew.s3.amazonaws.com/assets/uploads',
  tournament: 'tournament',
  DRAFT_ACCESS_TOKEN: 'draft_user',
  SITE_URL: 'https://drafters.info',
  leagueURL: 'https://drafters.info/league/profile',
  myTeamURL: 'https://drafters.info/manage-league/my-team',
  matchUpURL: 'https://drafters.info/league/matchup',
  playerURL: 'https://drafters.info/manage-league/players',
  settingsURL: 'https://drafters.info/league/settings',
  CURRENCY_SYMBOL: '$',
  SITE_CURRENCY: 'USD',
  PAYPAL_CLIENT_ID: 'AS7rPCc1hADE_xuq8mr7F77Wvc9ljpM_giG3g2mm469tes7CSi-c8saaKqvGHm66ub-9fiPNRDYRhxGN',
  SITE_TITLE: 'Drafters',
  S3_ACCESS_KEY: 'AKIAQSPDYLZKTFUFSLLB',
  S3_SECRET_KEY: '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',
  AWS_REGION: 'us-east-1',
  AWS_BUCKET: 'draftersnew',
  AWS_BUCKET_DIRECTORY: 'assets/uploads/chat/',
  ANGULAR_FOLDER_NMAE:'drafts',
  ONE_SIGNAL_APP_ID : '1d6f9668-1955-41b5-871f-bf5077b35159',
  REST_API_KEY : 'MWJlZmUxZmMtMjJmMC00Yjg3LTk2NWEtNzZiNDVkYWExMzRm',
  PAYPAL_MERCHANT_ID : 'AL7TWPC4TRNBL',
  IS_PHONE_VERIFICATION : false,
   NEW_SITE_URL: 'https://drafters.info/draftsv2'
};